module.exports = __webpack_public_path__ + "assets/img/Logitech-G-4-Social-Static-Ad-w720.5000fb65.webp";